export default __webpack_public_path__ + "static/media/src_jquery_mobile_5.aae0fb29.jpg";